import { createSignal } from '@verclam/pulsar';

/** Whether the confirmation before launching the generation is open. */
const generateConfirmSignal = createSignal<boolean>(false);

export const openGenerateConfirm = (): void => {
	generateConfirmSignal.value = true;
};

export const closeGenerateConfirm = (): void => {
	generateConfirmSignal.value = false;
};

export default generateConfirmSignal;
